// extracted by mini-css-extract-plugin
export var blueCardBox = "Submarine-module--blueCardBox--RGwu4";
export var leadership = "Submarine-module--leadership--r5+yV";
export var leadershipReverse = "Submarine-module--leadershipReverse--7kMJN";